/**
 * GAP-SOFT-DELETE (D24) §6: archiving DELETE mutations accept `id` or
 * `{ id, reason }`. The reason travels in the JSON body, never the URL, where
 * free text would reach proxy/access logs and browser history.
 */
export function archiveArgs(arg) {
  if (arg !== null && typeof arg === 'object') {
    return { id: arg.id, body: arg.reason ? { reason: arg.reason } : undefined };
  }
  return { id: arg, body: undefined };
}

/** Most specific message for a failed archive: `data.error`, then `detail`. */
export function archiveErrorMessage(err, fallback) {
  const data = err?.data;
  if (data && typeof data === 'object') {
    if (typeof data.error === 'string' && data.error) return data.error;
    if (typeof data.detail === 'string' && data.detail) return data.detail;
  }
  return fallback;
}

/**
 * Archive every id, unwrapping each call so failures are counted (RTK
 * trigger promises resolve even on error). Mirrors the policy runBulkAction.
 */
export async function runArchiveBatch(ids, archiveOne, singular, plural) {
  const results = await Promise.allSettled(ids.map((id) => archiveOne(id).unwrap()));
  const failedIds = ids.filter((_, i) => results[i].status === 'rejected');
  if (failedIds.length === 0) return { failedIds, message: null };
  const reasons = [
    ...new Set(
      results
        .filter((r) => r.status === 'rejected')
        .map((r) => archiveErrorMessage(r.reason, 'Request failed.'))
    ),
  ].join('; ');
  const noun = ids.length === 1 ? singular : plural;
  return {
    failedIds,
    message: `Failed to archive ${failedIds.length} of ${ids.length} ${noun}: ${reasons}`,
  };
}
